import React from "react";
import s from "./Loader.module.css";

const Loader = () => {
  return <h1 className={s.loader}>Loading...</h1>;
};

export default Loader;
